import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { MgOrgPartnerSelect } from '@/share/components/xeui/form-items/mg-org-partner-select';
import { useFormItemRender } from '@/share/components/xeui/use';
export default {
  __name: 'mg-org-partner-select',
  props: {
    renderOpts: {
      type: Object,
      default: () => ({})
    },
    renderParams: {
      type: Object,
      default: () => ({})
    }
  },
  setup(__props) {
    const props = __props;
    const {
      formData,
      fieldName,
      fieldOptions
    } = useFormItemRender(props);
    return (_ctx, _cache) => {
      return _unref(formData) && _unref(fieldName) ? (_openBlock(), _createBlock(_unref(MgOrgPartnerSelect), _mergeProps({
        key: 0,
        modelValue: _unref(formData)[_unref(fieldName)],
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(formData)[_unref(fieldName)] = $event)
      }, _unref(fieldOptions)), null, 16, ["modelValue"])) : _createCommentVNode("", true);
    };
  }
};